/**
 * List of Epc read modes in Encoding Operation
 *
 * @namespace tmrEncodingEpcReadModes
 * @type {ngConstant}
 */
export const constant = [
  'tmrEncodingEpcReadModes',
  {
    reader: 'OPERATIONS.ENCODING.EPCREADMODES.READER',
    barcode: 'OPERATIONS.ENCODING.EPCREADMODES.BARCODE',
  },
]

/**
 * Translates {@link tmrEncodingEpcReadModes}
 *
 * @type {ngRun}
 */
let tmrEncodingEpcReadModesRun = /*@ngInject*/ (
  TmrTranslate,
  tmrEncodingEpcReadModes
) => TmrTranslate.object(tmrEncodingEpcReadModes)

export { tmrEncodingEpcReadModesRun as run }
